<template>
  <div class="fz-input-button">
    <div class="fz-input-button__items">
      <SfInput
        class="fz-input-button__input"
        v-bind="$attrs"
        :value="value"
        v-on="listeners"
      />
    </div>
    <div class="fz-input-button__items">
      <SfButton
        class="fz-input-button__button sf-button--outline sf-button--full-width"
        v-bind="button"
      >
        <slot/>
      </SfButton>
    </div>
  </div>
</template>
<script>
import { SfInput, SfButton } from '@storefront-ui/vue';

export default {
  name: 'InputWithButton',
  components: {
    SfInput,
    SfButton,
  },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    button: {
      type: Object,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: (value) => this.$emit('input', value),
      };
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (!this.isNumberTypeSafari) return;
        if (Number.isNaN(value)) {
          this.$emit('input');
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint";

.fz-input-button {
  margin: var(--spacer-sm) auto;
  @include flexbox-desktop {
    display: flex;
  }
}

.fz-input-button__items {
  @include flexbox-desktop {
    &:first-child {
      width: 70%;
    }
    &:last-child {
      width: 30%;
    }
  }
}

.fz-input-button__input {
  --input-bar-background: var(--_c-gray-secondary);
}

.fz-input-button__button {
  --button-border-color: var(--_c-gray-secondary);
  --button-color: var(--_c-gray-secondary);
  --button-border-width: 1px;
  --button-padding: 12px 20px 13px;
}
</style>
